import { api } from '../../lib/api.ts';

export interface CatalogItem {
  id: string;
  name: string;
  unit: string | null;
  defaultSpec: string | null;
}

export const catalogApi = {
  list: (params: { search?: string } = {}) =>
    api.get<{ items: CatalogItem[] }>('/catalog', { params }).then((r) => r.data.items),
};
